<section class="widget-page">
  <div class="d-flex align-items-center gap-3 mb-3">
    <div class="d-flex align-items-center gap-2">
      <h6 class="mb-0 page-title" i18n>Inquiry Widget</h6>

      <app-page-help [articleId]="'zaokdn0igu'" videoId="-"></app-page-help>
    </div>
    <div class="flex-fill"></div>
    <a routerLink="/widgets" class="btn btn-secondary-primary">
      <i class="far fa-chevron-left"></i> <ng-container i18n>Back to Widgets</ng-container>
    </a>
  </div>
  <div class="main-content">
    <div class="container-box details-box">
      <div class="box-body">
        <div class="row">
          <div class="col-lg-6 col-xl-5">
            <div class="widget-holder p-3">
              <div class="alert alert-secondary-info">
                <i class="cs-icon cs-icon-info-circle alert-icon"></i>
                <div class="aler-content" i18n>
                  Inquiry widgets allow you to capture inquiries on any website. Simply copy and paste the widget code
                  to your bookings webpage.
                </div>
              </div>

              <form [formGroup]="form">
                <div class="clearfix widget-box">
                  <h4 class="title">
                    <ng-container i18n>1. Select a Rental</ng-container> <span class="red-star">*</span>
                    <app-info-icon
                      i18n-tooltipText
                      tooltipText="The inquiry widget is rental specific. Only one rental can be selected in this configuration."
                    ></app-info-icon>
                  </h4>
                  <div class="row">
                    <div class="col-sm-12">
                      <app-rental-select
                        [multiple]="false"
                        [ctrl]="form.get('rental')"
                        i18n-placeholder
                        placeholder="Rental"
                      ></app-rental-select>
                    </div>
                  </div>
                </div>

                <!-- ***if want to disable/pointer-event:none for this section***
                  <div class="clearfix widget-box disabled"> -->

                <div class="clearfix widget-box">
                  <h4 class="title">
                    <ng-container i18n>2. Give your widget a unique source name</ng-container>
                    <span class="red-star">*</span>
                    <app-info-icon
                      tooltipText="The source will show as a filterable option on the Inquiry List and Inbox views. If you have rentals associated with different websites, this option will allow you to differentiate inquiries coming from each."
                    ></app-info-icon>
                  </h4>
                  <div class="row">
                    <div class="col-sm-12">
                      <mat-form-field2 class="mat-block">
                        <input
                          type="text"
                          matInput
                          i18n-placeholder
                          placeholder="Source Name"
                          formControlName="source"
                        />
                      </mat-form-field2>
                    </div>
                  </div>
                </div>

                <div class="clearfix widget-box">
                  <h4 class="title">
                    3. Submit Button Style
                    <app-info-icon
                      i18n-tooltipText
                      tooltipText="Your changes can be viewed in the widget preview to the right of this configuration menu."
                    ></app-info-icon>
                  </h4>
                  <div class="row">
                    <div class="col-sm-4">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          [value]="form.get('color').value"
                          i18n-placeholder
                          placeholder="Font Color"
                          [colorPicker]="form.get('color').value"
                          [cpOutputFormat]="'hex'"
                          [cpPosition]="'bottom'"
                          (colorPickerChange)="onColorSelected('color', $event)"
                          required
                        />
                        <mat-icon
                          matSuffix
                          fontSet="fas"
                          fontIcon="fa-circle"
                          class="color-picker-value-indicator"
                          [style.color]="form.get('color').value"
                        ></mat-icon>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          [value]="form.get('backgroundColor').value"
                          i18n-placeholder
                          placeholder="Background Color"
                          [colorPicker]="form.get('backgroundColor').value"
                          [cpOutputFormat]="'hex'"
                          [cpPosition]="'bottom'"
                          (colorPickerChange)="onColorSelected('backgroundColor', $event)"
                          required
                        />
                        <mat-icon
                          matSuffix
                          fontSet="fas"
                          fontIcon="fa-circle"
                          class="color-picker-value-indicator"
                          [style.color]="form.get('backgroundColor').value"
                        ></mat-icon>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          [value]="form.get('borderColor').value"
                          i18n-placeholder
                          placeholder="Border Color"
                          [colorPicker]="form.get('borderColor').value"
                          [cpOutputFormat]="'hex'"
                          [cpPosition]="'bottom'"
                          (colorPickerChange)="onColorSelected('borderColor', $event)"
                          required
                        />
                        <mat-icon
                          matSuffix
                          fontSet="fas"
                          fontIcon="fa-circle"
                          class="color-picker-value-indicator"
                          [style.color]="form.get('borderColor').value"
                        ></mat-icon>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          type="number"
                          matInput
                          required
                          i18n-placeholder
                          placeholder="Border Width (px)"
                          formControlName="borderWidth"
                        />
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <mat-select
                          placeholder="Border Radius"
                          i18n-placeholder
                          formControlName="borderRadius"
                          required
                        >
                          <mat-option *ngFor="let size of borderRadiusOpts" [value]="size">
                            {{ size }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field2>
                    </div>
                  </div>
                </div>

                <div class="alert alert-secondary-info">
                  <i class="cs-icon cs-icon-info-circle alert-icon"></i>
                  <div class="aler-content" i18n>
                    Removing the word "widget" from the data-name= field below will prevent Automata from firing
                    triggers that have AdvanceCM Widget assigned as a channel.
                  </div>
                </div>

                <div class="clearfix widget-box">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        role="tab"
                        [ngClass]="{ active: widgetType === 'simple' }"
                        (click)="onChangeWidgetType('simple')"
                        aria-controls="simple"
                        i18n
                        >Simple</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        [ngClass]="{ active: widgetType === 'extended' }"
                        role="tab"
                        (click)="onChangeWidgetType('extended')"
                        aria-controls="extended"
                        i18n
                        >Extended</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        [ngClass]="{ active: widgetType === 'extendedwide' }"
                        role="tab"
                        (click)="onChangeWidgetType('extendedwide')"
                        aria-controls="extendedwide"
                        i18n
                        >ExtendedWide</a
                      >
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane fade show active">
                      <div class="alert alert-dark">
                        <p class="widget-code" [innerText]="widgetCode"></p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="clearfix widget-box">
                  <h4 class="title" i18n>4. Copy and paste the desired widget code onto your website.</h4>
                  <div class="row">
                    <div class="col-sm-12 btn-holder">
                      <button
                        type="button"
                        class="btn btn-secondary-light"
                        [disabled]="!widgetCode"
                        ngxClipboard
                        [cbContent]="widgetCode"
                        (cbOnSuccess)="onCopied($event)"
                      >
                        <span class="fal fa-copy"></span>
                        <ng-container i18n>copy code</ng-container>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-lg-6 col-xl-7">
            <div class="widget-preview d-flex align-items-center flex-column h-100 p-3">
              <h5 class="title text-light" i18n>Widget Preview</h5>

              <div class="preview-box flex-fill w-100">
                <iframe
                  *ngIf="trustedWidgetCode"
                  [srcdoc]="trustedWidgetCode"
                  frameborder="0"
                  class="w-100 h-100"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
